// extracted by mini-css-extract-plugin
export default {"button":"FormButtons_button__bvS8w"};